import {ListQueryParams, ApiResponse} from '../ApiClient'
import {GetAPIDomain, GetAPIHeaders} from '../Helper'

export class PermissionQueryParams extends ListQueryParams {
}

export class PermissionsClient {
    static async List(params: PermissionQueryParams) {
        let query = (await GetAPIDomain()) + '/permissions' + params.GenerateQueryString();

        return await ApiResponse.Create(() => fetch(query, {
                headers: GetAPIHeaders(),
                credentials: 'include',
            })
        )
    }

    static async ListGrouped(params: PermissionQueryParams) {
        let query = (await GetAPIDomain()) + '/permissions/grouped' + params.GenerateQueryString();

        return await ApiResponse.Create(() => fetch(query, {
                headers: GetAPIHeaders(),
                credentials: 'include',
            })
        )
    }

    static async ForCurrentUser() {

        console.log("ForCurrentUser");

        let apiDomain = await GetAPIDomain();
        return await ApiResponse.Create(() => fetch(apiDomain + '/permissions/for/current-user', {
                method: 'GET',
                credentials: 'include',
                headers: GetAPIHeaders(),
            })
        )
    }
}
